<template>
  <b-modal :modelValue="deal !== null"
           :title="helper.trans('labels.assign_trader')"
           footer-class=" d-flex justify-content-between"
           @update:modelValue="$event === false && (deal = null)">
    <template #default>

      <div class="row">
        <div class="col-sm-12">
          <TraderMultiselect :multiple="false" :small="false" v-model="trader">
          </TraderMultiselect>
        </div>
      </div>

    </template>
    <template #footer>
      <button type="button" @click="deal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{  helper.trans('button.cancel')  }}
      </button>

      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import ExtendedDealDTO from "@/models/ExtendedDealDTO";
import {DatePicker} from "v-calendar";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import TraderDTO from "@/models/TraderDTO";

export default defineComponent({
  components: {
    TraderMultiselect,
    DatePicker,
    BModal,
    LoaderWrapper
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      deal: null as ExtendedDealDTO|null,
      onOkClick: null as any,
      trader: null as TraderDTO|null
    });

    const show = (deal: ExtendedDealDTO, onOkClick: any) => {
      state.deal = deal
      state.onOkClick = onOkClick;
      state.trader = null
    }

    const onOkClick = async () => {
      if (!state.deal) {
        return;
      }

      loader.value?.show()
      try {
        await state.onOkClick({
          trader: state.trader
        })
      } finally {
        loader.value?.hide()
      }

      state.deal = null;
    }


    return {
      ...toRefs(state),
      onOkClick,
      show,
      loader,
      helper
    }
  }
})
</script>
